import { Component, OnInit } from '@angular/core';
import { ValidateQrService } from '../validate-qr.service';
import { TotemService } from '../totem.service';
import { ActivatedRoute } from '@angular/router';
import { AnalyticsService } from '../services/analytics.service';
import { StorageService } from '../storage.service';

@Component({
  selector: 'app-mensaje-qr',
  templateUrl: './mensaje-qr.component.html',
  styleUrls: ['./mensaje-qr.component.css']
})
export class MensajeQrComponent implements OnInit {

  public qrid: string;

  constructor(
    private validateQr: ValidateQrService,
    private totemService: TotemService,
    private route: ActivatedRoute,
    private analytics: AnalyticsService,
    private storage: StorageService
  ) {}

  ngOnInit() {
    this.qrid = this.route.snapshot.paramMap.get('qrid') || '';

    // === GA4: envio de ruta al movil (QR) ===
    // Cuando el usuario llega a esta pantalla significa que se esta mostrando
    // el QR para transferir la ruta a su movil. Lo registramos una vez por vista.
    try {
      const datos: any = this.storage.getNodosRuta && this.storage.getNodosRuta();
      this.analytics.trackQrSendToMobile({
        qr_id: this.qrid || 'inline',
        destination_id: datos ? datos.destino : undefined,
        destination_name: datos ? (datos.nombreDestino || '') : undefined,
        method: 'qr'
      });
    } catch (err) {
      console.warn('GA4 trackQrSendToMobile error', err);
    }
  }
}
